import { AgGridReact } from 'ag-grid-react'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import 'ag-grid-enterprise'

import { getLanguageCodes } from '../../../actions/competences/languages/languagecodesget'
import { deleteLanguage } from '../../../actions/competences/languages/languagedelete'
import { getLanguage } from '../../../actions/competences/languages/languageget'
import { postLanguage } from '../../../actions/competences/languages/languagepost'
import { getAllLanguagesForPerson } from '../../../actions/competences/languages/languagesgetallforperson'
//import { getAllLanguagesForPersonModified } from '../../../actions/competences/languages/languagesgetallforpersonmodified'
import { getAllLanguagesForPersons } from '../../../actions/competences/languages/languagesgetallforpersons'
//import { getAllLanguagesModified } from '../../../actions/competences/languages/languagesgetallmodified'
import { addGridData, getLocaleText, removeGridData, resetSorting, updateGridData } from '../../../actions/datagrid'
import {
	contextMenu,
	defaultColDef,
	gridSettings,
	loadViewState,
	restoreViewState,
	saveViewState,
	sideBar,
	statusBar,
} from '../../../common/grid'
import { pencilIconString, restoreIconString, TemplateProfileImage, trashIconString } from '../../../common/icons'
import { PdfReport } from '../../../common/pdfreport'
import { fetchSettings } from '../../../common/settings.js'
import { localized /*useInterval*/ } from '../../../common/utils'
import {
	actionTypeSelector,
	authSelector,
	languageCodesSelector,
	languageSelector,
	/*languagesModifiedSelector,*/
	languagesSelector,
} from '../../../reducers'
import { AddLanguage } from './languagemodal'

const viewStateKey = 'languagesViewState'

// finds language code in codes[] and swaps it by idx in arr
const swapArrayLanguages = (arr, codes) => {
	for (let i = 0; i < codes.length; ++i) {
		const temp = arr[i]
		const searchIdx = arr.findIndex((elem) => elem[1] === codes[i])
		arr[i] = arr[searchIdx]
		arr[searchIdx] = temp
	}
}

export default function LanguagesView({ person }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const path = window.location.pathname
	const isPersonal = path.startsWith('/personal')

	const saveLanguage = useCallback((languageData) => dispatch(postLanguage(languageData)))
	const removeLanguage = useCallback(
		({ id, data: { personName } }) => {
			if (confirm(`${t('DeleteLanguageConfirm', 'Haluatko varmasti poistaa kielitaidon?')} (${personName})`)) {
				dispatch(deleteLanguage(id))
			}
		},
		[t, dispatch],
	)

	const { admin, companyName } = useSelector(authSelector)
	const actionType = useSelector(actionTypeSelector)
	const languageCodes = useSelector(languageCodesSelector)
	const languages = useSelector(languagesSelector)
	const language = useSelector(languageSelector)

	const [settings, setSettings] = useState({})

	const [report, setReport] = useState(null)
	const closeReport = () => setReport(null)

	const [languageOptions, setLanguageOptions] = useState([])
	const [modalShow, setModalShow] = useState(false)
	const [showLoading, setShowLoading] = useState(false)

	const gridRef = useRef()

	const generateLanguageOptions = useCallback(() => {
		const languageMap = languageCodes.map((code) => [localized.languageName.of(code), code]).sort() // localeCompare()
		swapArrayLanguages(languageMap, ['fi', 'sv', 'en', 'de', 'fr'])
		setLanguageOptions(
			languageMap.map((arr) => ({
				value: arr[1],
				label: `${arr[0]} (${arr[1]})`,
			})),
		)
	}, [languageCodes])

	useEffect(() => {
		dispatch(getLanguageCodes())
		if (!person && !isPersonal) {
			dispatch(getAllLanguagesForPersons(true))
		}
		return () => dispatch({ type: 'LANGUAGESKILLS_UNMOUNT', payload: { languages: null, language: null } })
	}, [dispatch, person, isPersonal])

	useEffect(() => {
		dispatch(getLanguageCodes())
		if (person) {
			if (person?.personId) {
				dispatch(getAllLanguagesForPerson(person?.personId))
			}
		}
	}, [dispatch, person])

	useEffect(() => {
		;(async () => {
			setSettings(await fetchSettings())
		})()
	}, [])
	/*
	const fetchModifiedLanguages = useCallback((modifiedSince) => dispatch(getAllLanguagesModified(modifiedSince)))
	const fetchModifiedLanguagesForPerson = useCallback((personId, modifiedSince) =>
		dispatch(getAllLanguagesForPersonModified(person?.personId, modifiedSince)),
	)
	const [modifiedSince, setModifiedSince] = useState(Date.now())
	if (import.meta.env.TEST) {
		// production
		// Poll modified languages every 30 seconds
		useInterval(() => {
			const tmpModifiedSince = modifiedSince
			setModifiedSince(Date.now())
			if (person?.personId) {
				fetchModifiedLanguagesForPerson(person?.personId, tmpModifiedSince)
			} else {
				fetchModifiedLanguages(tmpModifiedSince)
			}
		}, 30 * 1000)
	}
	const languagesModified = useSelector(languagesModifiedSelector)
	useEffect(() => {
		if (gridRef.current.api) {
			if (languagesModified?.newLanguages?.length > 0) {
				addGridData(gridRef, languagesModified.newLanguages, 0)
			}
			if (languagesModified?.modifiedLanguages?.length > 0) {
				updateGridData(gridRef, languagesModified.modifiedLanguages)
			}
			if (languagesModified?.deletedLanguages?.length > 0) {
				removeGridData(gridRef, languagesModified.deletedLanguages)
			}
		}
	}, [languagesModified])
*/
	useEffect(() => {
		if (actionType === 'GET_LANGUAGE_CODES_SUCCEEDED') {
			generateLanguageOptions()
		} else if (actionType.endsWith('_LOADING')) {
			setShowLoading(true)
		} else if (actionType.endsWith('_SUCCEEDED') || actionType.endsWith('_FAIL') || actionType.endsWith('_DONE')) {
			setShowLoading(false)
		}
		if (actionType === 'POST_LANGUAGE_SUCCEEDED') {
			resetSorting(gridRef)
			addGridData(gridRef, [language], 0)
		}
		if (actionType === 'POST_LANGUAGE_EDIT_SUCCEEDED') {
			updateGridData(gridRef, [language])
		}
		if (actionType === 'UPLOAD_DONE') {
			person?.personId
				? dispatch(getAllLanguagesForPerson(person?.personId))
				: dispatch(getAllLanguagesForPersons(true))
			setModalShow(false)
		}
		if (actionType === 'GET_LANGUAGE_SUCCEEDED') {
			setModalShow(true)
		}
		if (actionType === 'DELETE_LANGUAGE_SUCCEEDED') {
			removeGridData(gridRef, [language])
		}
	}, [actionType, language, generateLanguageOptions, dispatch, person])

	const gridComponents = {
		templateProfileImage: TemplateProfileImage,
	}

	const columnDefs = useMemo(
		() => [
			{
				headerName: t('Number', 'Numero'),
				field: 'personNumber',
				filter: 'agNumberColumnFilter',
				suppressSizeToFit: true,
				minWidth: 115,
				maxWidth: 115,
				width: 115,
			},
			{
				headerName: t('Name', 'Nimi'),
				field: 'personName',
				width: 150,
			},
			{
				headerName: t('LanguageCode', 'Kielen tunnus'),
				field: 'languageCode',
				filter: 'agSetColumnFilter',
				width: 125,
			},
			{
				headerName: t('Language', 'Kieli'),
				valueGetter: (params) =>
					languageOptions
						.find((option) => params.data && option.value === params.data.languageCode)
						?.label.slice(0, -5),
				field: 'languageCode',
				filter: 'agSetColumnFilter',
				width: 125,
			},
			{
				headerName: t('LevelDescription', 'Tason selite'),
				field: 'languageSkillLevel',
				filter: 'agSetColumnFilter',
				tooltipField: 'languageSkillLevel',
			},
			{
				field: 'supervisor',
				headerName: t('Supervisor', 'Esihenkilö'),
			},
			{
				field: 'supervisor2',
				headerName: `${t('Supervisor', 'Esihenkilö')} 2`,
			},
			{
				field: 'dim1',
				headerName: settings.dim1name || t('Dimension1', 'Kustannuspaikka'), // costUnitName
			},
			{
				field: 'dim2',
				headerName: settings.dim2name || t('Dimension2', 'Projekti'), // projectName
			},
			{
				field: 'dim3',
				headerName: settings.dim3name || t('Dimension3', 'Dimensio 3'),
			},
			{
				field: 'dim4',
				headerName: settings.dim4name || t('Dimension4', 'Dimensio 4'),
			},
			{
				field: 'dim5',
				headerName: settings.dim5name || t('Dimension5', 'Dimensio 5'),
			},
			{
				field: 'dim6',
				headerName: t('BusinessId', 'Y-tunnus'),
			},
			{
				headerName: t('Comment', 'Kommentti'),
				field: 'comment',
				tooltipField: 'comment',
			},
		],
		[t, settings, languageOptions],
	)

	const initialState = useMemo(
		() => ({
			columnVisibility: {
				...(isPersonal || person
					? { hiddenColIds: ['personNumber', 'personName', 'languageCode'] }
					: { hiddenColIds: ['supervisor', 'supervisor2'] }),
			},
		}),
		[isPersonal, person],
	)

	const getContextMenuItems = useCallback(
		(params) => {
			let items = []

			if (!isPersonal) {
				items.push({
					name: t('DefaultGridValues', 'Palauta taulukon oletusasetukset'),
					action: () => {
						restoreViewState(viewStateKey, initialState)
					},
					icon: restoreIconString,
				})

				items.push('separator')
			}

			if (!params.api.isPivotMode()) {
				items.push({
					name: t('Edit', 'Muokkaa'),
					icon: pencilIconString,
					action: () => dispatch(getLanguage(params.node.id)),
				})

				if (admin) {
					items.push({
						name: t('Delete', 'Poista'),
						icon: trashIconString,
						action: () => removeLanguage(params.node),
					})
				}
				items.push('separator')
			}
			items = items.concat(
				contextMenu(t, params, setReport, {
					title: t('LanguageSkill', 'Kielitaito'),
					companyname: companyName,
				}),
			)
			return items
		},
		[companyName, admin, t, initialState, isPersonal, removeLanguage, dispatch],
	)

	const doubleClickAction = (row) => {
		if (row.data?.languageId) {
			dispatch(getLanguage(row.data.languageId))
		}
	}

	return (
		<>
			{report !== null && <PdfReport json={report} onCloseReport={closeReport} />}
			{!location.pathname.startsWith('/mgmt/persons') && (
				<Row>
					<Col sm="4"></Col>
					<Col sm="8" align="right">
						<Row className="g-2">
							<Col>
								<AddLanguage
									show={modalShow}
									setShow={setModalShow}
									languageOptions={languageOptions}
									languageData={language}
									saveData={saveLanguage}
									person={person}
								/>
							</Col>
						</Row>
					</Col>
				</Row>
			)}
			<Row className="ag-theme-material styles-ag flex-grow-1">
				<AgGridReact
					{...gridSettings}
					loading={showLoading}
					ref={gridRef}
					components={gridComponents}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					sideBar={sideBar}
					rowData={languages}
					getContextMenuItems={getContextMenuItems}
					statusBar={statusBar}
					onRowDoubleClicked={doubleClickAction}
					getRowId={(params) => String(params.data.languageId)}
					getLocaleText={(params) => getLocaleText(t, params)}
					animateRows
					suppressCellFocus
					enableCellTextSelection
					initialState={isPersonal || person ? initialState : loadViewState(viewStateKey)}
					onStateUpdated={({ state }) => !isPersonal && saveViewState(state, viewStateKey)}
					debug={import.meta.env.DEV}
				/>
			</Row>
		</>
	)
}
